import { sha256 } from "js-sha256";
import { Bank } from "./Bank";
const baseUrl = process.env.REACT_APP_API_URL;
import PaymentService  from "../payment.service";
export class Bancomer extends Bank {
    constructor(){
        super('bbva','multipart')
        this.url =  process.env.REACT_APP_MP_URL
        this.concept = {
          "Contado": "Pagos de Contado",
          "Anticipo": "Pagos de Anticipo",
        }
        this.paymentMethods = {
          multipart : this.startMultipartPayment.bind(this),
        }
    }
    
    hash(data){
      
        return sha256.hmac(
            process.env.REACT_APP_KEY,
            `${data.an8}${data.reference}${
              data.amount > 0 ? Number.parseFloat(data.amount).toFixed(2) : 0
            }`.trim()
          )
    }


        /**
* Servicio MultipartPayment
* Inicia el servicio de pagos con esquema multipart
* @author Kenzo Sashida - ETE
* @version 1.0.0 - Enero 2025 -Servicio pagos esquema multipart
*/
    startMultipartPayment(dataPaymentForm){
      const data = this.getFormFields(dataPaymentForm)
      const form = document.createElement("form")
      form.action = this.url
      form.method = "post"
      form.target = "_blank"    
      data.forEach(el => {
        const input = document.createElement("input")
        input.name= el.name
        input.value = el.value
        input.type = "hidden"
        form.appendChild(input)
      });
      document.body.appendChild(form)
      form.submit()
     // document.body.removeChild(form)
    }
    /**
* Comienza el servicio de almacenar pagos
* Funcion que almacena pagos 
* @author Kenzo Sashida - ETE
* @version 1.0.0 - Diciembre 2024 -Servicio para almacenar pagos
*/
   async savePaymentRequest(data, an8){
    
        let dataPaymentContent = {
            account: process.env.REACT_APP_MP_ACCOUNT,
            product: process.env.REACT_APP_MP_PRODUCT,
            order: data.an8?.trim(),
            reference: data.reference?.trim(),
            node: process.env.REACT_APP_MP_NODE,
            concept: process.env.REACT_APP_MP_CONCEPT,
            amount: data.amount > 0 ?Number.parseFloat(data.amount).toFixed(2).trim(): 0,
            signature: sha256.hmac(
                      process.env.REACT_APP_KEY,
                      `${data.an8}${data.reference}${
                        data.amount > 0 ? Number.parseFloat(data.amount).toFixed(2) : 0
                      }`.trim()
                    ),
            customername: data.clientName?.trim(),
            currency: process.env.REACT_APP_MP_CURRENCY,
            urlsuccess: baseUrl + process.env.REACT_APP_MP_URLSUCCESS,
            urlfailure: baseUrl + process.env.REACT_APP_MP_URLFAILURE,
        };
        try{
            const response = await PaymentService.savePaymentRequest(dataPaymentContent, an8)
            if(!response.data)throw new Error("Error al almacenar el pago.")
            return {success:"Ok"}
        }catch(err){
            return {error: err.message}

        }
    }
              /**
   * getFormFields
   * Funcion que genera los campos necesarios para enviar al banco
   * @author Kenzo Sashida - ETE
   * @version 1.0.0 - Enero 2025 - Enviar inputs establecidos por el banco
   */
    getFormFields(data){
      return  [
            { name: "mp_account", value: process.env.REACT_APP_MP_ACCOUNT,},
            { name: "mp_product", value: process.env.REACT_APP_MP_PRODUCT, },
            { name: "mp_order",value: data.an8?.trim() },
            { name: "mp_reference", value: data.reference?.trim(),  },
            { name: "mp_node", value:  process.env.REACT_APP_MP_NODE },
            { name: "mp_concept", value: process.env.REACT_APP_MP_CONCEPT,},
            { name: "mp_amount", value: data.amount > 0 ?Number.parseFloat(data.amount).toFixed(2).trim(): 0, },
            { name: "mp_signature", value: sha256.hmac(
                process.env.REACT_APP_KEY,
                `${data.an8}${data.reference}${
                  data.amount> 0 ? Number.parseFloat(data.amount).toFixed(2) : 0
                }`.trim()
              ),},
            { name: "mp_customername", value: data.clientName?.trim()},
            { name: "mp_currency", value: process.env.REACT_APP_MP_CURRENCY},
            { name: "mp_urlsuccess", value: baseUrl + process.env.REACT_APP_MP_URLSUCCESS },
            { name: "mp_urlfailure", value: baseUrl + process.env.REACT_APP_MP_URLFAILURE},
        ]
        
    }

}